import type { ButtonHTMLAttributes, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "../../LoadingAnimations/LoadingAnimations";
import "./button.css";

type ButtonVariant = "primary" | "secondary" | "positive" | "negative";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children?: ReactNode;

  /**
   * Translation key from your i18n files.
   * Example: labelKey="create"
   */
  labelKey?: string;
  variant?: ButtonVariant;
  isLoading?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

export function Button({
  children,
  labelKey,
  variant = "primary",
  isLoading = false,
  className = "",
  disabled,
  type = "button",
  ...props
}: ButtonProps) {
  const { t } = useTranslation();

  const content = isLoading ? (
    <Spinner />
  ) : labelKey ? (
    t(`common:actions.${labelKey}`)
  ) : (
    children
  );

  const buttonClassName = ["yms-btn", `yms-btn--${variant}`, className]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type={type}
      className={buttonClassName}
      disabled={disabled || isLoading}
      aria-busy={isLoading}
      {...props}
    >
      {content}
    </button>
  );
}
